export default import.meta.ROLLDOWN_FILE_URL_5jv9CescG8lLlhiYdovToQ